import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import { Outlet, useSearchParams } from "react-router-dom";
import { Container, useTheme } from "@mui/material";

export default function Spa() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const isOnboarding = searchParams.get("newUser") === "true";

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isFabAnimated, setIsFabAnimated] = useState(false);
  const drawerWidth = isOnboarding ? 0 : 240;

  useEffect(() => {
    // Prevents image context menu on Android — iOS is handled via -webkit-touch-callout in index.js.
    // Scoped to img elements only so links and text retain their native context menus.
    const isTouchDevice =
      window.matchMedia("(pointer: coarse)").matches ||
      navigator.maxTouchPoints > 0;

    if (!isTouchDevice) return;

    const preventImageContextMenu = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };

    document.addEventListener("contextmenu", preventImageContextMenu);
    return () =>
      document.removeEventListener("contextmenu", preventImageContextMenu);
  }, []);

  // Opens/closes the drawer on mobile
  const handleDrawerToggle = () => {
    if (!isClosing) setMobileOpen((prev) => !prev);
  };

  // Called exclusively by MUI Drawer's onClose prop (backdrop tap or Escape key).
  // Sets isClosing to prevent the toggle firing mid-animation.
  // isClosing is reset by handleDrawerTransitionEnd once the animation completes.
  const handleBackdropClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  // Resets isClosing once the drawer's close animation has completed
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  // Used for programmatic closes from nav items and other UI actions.
  // Does NOT set isClosing — MUI handles the animation automatically
  // when mobileOpen changes, and nothing will try to reopen it mid-animation.
  const closeDrawer = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <ResponsiveDrawer
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        handleDrawerTransitionEnd={handleDrawerTransitionEnd}
        handleBackdropClose={handleBackdropClose}
        closeDrawer={closeDrawer}
        drawerWidth={drawerWidth}
        isFabAnimated={isFabAnimated}
      />

      <Container
        component="main"
        sx={{
          flexGrow: 1,
          // changed from 100vh for better mobile support; shrunk by the safe-area top
          // inset and the campaign banner's height (both 0px when not applicable — see
          // --top-offset in index.js) so the page doesn't overflow the viewport when
          // either pushes content down — see features/campaign
          height: "calc(100dvh - var(--top-offset, 0px))",
          // overflow: "auto", // can't apply this as prevents infinite scroll components
          // from triggering when scrolling to the bottom of the page
          // overflowX: "hidden",
          pb: 2,
          maxWidth: {
            xs: "100%",
            md: `min(calc(100% - ${drawerWidth}px), ${theme.breakpoints.values.lg}px)`,
          },
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Outlet
          context={{
            toggleDrawer: handleDrawerToggle,
            drawerWidth,
            setIsFabAnimated,
          }}
        />
      </Container>
    </Box>
  );
}
